/** Fragment IDs for on-prem Test page → DTA gateway flow (AHB submit / reply blocks). */
export const ONPREM_DTA_GATEWAY_ANCHOR_IDS = {
  replyFromInsurance: "onprem-dta-reply-from-insurance",
  submitToInsurance: "onprem-dta-submit-to-insurance",
} as const;
